var _path, _path2, _ellipse, _path3, _ellipse2, _ellipse3, _circle, _circle2, _path4, _path5, _path6, _path7, _rect, _ellipse4, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 50 C22 66 24 80 30 88 C34 80 33 70 36 62 Z",
    fill: "#546251"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50 C78 66 76 80 70 88 C66 80 67 70 64 62 Z",
    fill: "#546251"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 63,
    rx: 17,
    ry: 18,
    fill: "#F6D7BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56 C38 50 44 52 50 50 C56 52 62 50 67 56 C66 50 60 46 50 46 C40 46 34 50 33 56 Z",
    fill: "#546251"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43,
    cy: 62,
    rx: 2.2,
    ry: 2.8,
    fill: "#2b1650"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57,
    cy: 62,
    rx: 2.2,
    ry: 2.8,
    fill: "#2b1650"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 69,
    r: 2.6,
    fill: "#F2A8A0",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 69,
    r: 2.6,
    fill: "#F2A8A0",
    opacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63 L53 69 L49 69 Z",
    fill: "#E9B998"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73 Q50 77 55 73",
    stroke: "#2b1650",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 47 L46 14 C49 7 56 4 63 6 C57 9 55 13 56 20 L67 47 Z",
    fill: "#F9F5F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 41 L64.5 41 L66.5 46.5 L33.5 46.5 Z",
    fill: "#F5A926"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 40.5,
    width: 8,
    height: 6.5,
    rx: 1,
    fill: "none",
    stroke: "#502887",
    strokeWidth: 1.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 48,
    rx: 29,
    ry: 5,
    fill: "#F9F5F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24 L52.2 27.3 L55.6 27.4 L52.9 29.5 L53.9 32.8 L51 30.8 L48.1 32.8 L49.1 29.5 L46.4 27.4 L49.8 27.3 Z",
    fill: "#F5A926"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18 L85.5 22 L89.5 23.5 L85.5 25 L84 29 L82.5 25 L78.5 23.5 L82.5 22 Z",
    fill: "#F5A926"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26 L17 28.5 L19.5 29.5 L17 30.5 L16 33 L15 30.5 L12.5 29.5 L15 28.5 Z",
    fill: "#F5A926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWitch);
export default __webpack_public_path__ + "static/media/witch.4fd91515b3159c8a3a2e177d2c1166aa.svg";
export { ForwardRef as ReactComponent };